const ncmMask4 = [/\d/, /\d/, '.', /\d/, /\d/, /\d/];
const ncmMask6 = [/\d/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/];
const ncmMask8 = [/\d/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/];

export default { ncmMask4, ncmMask6, ncmMask8 };
